import React from "react";
import Aboutus1 from "../components/Aboutus/Aboutus1";
// import ClientCarousel from "../components/landingpage/ClientCarousel";
// import data from "../json/Aboutus/Clientcarousel.json";
import Leadership from "../components/Aboutus/Leadership";
import Journey from "../components/Aboutus/Journey";
// import Testimonial from "../components/landingpage/Testimonial";
import Testimonialnew from "../components/landingpage/Testimonialnew";
import Section4 from "../components/Allcontent/Section4";
import data from '../json/Aboutus/Aboutus1.json'
import Aboutus2 from "../components/Aboutus/Aboutus2";
import parse from "html-react-parser"
import SEO from "../components/SEO";

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "mainEntity": {
    "@type": "Organization",
    "name": "Transforma Pvt Ltd",
    "url": "https://www.transforma.in/company/Aboutus",
    "logo": "https://www.transforma.in/images/transformalogo.svg",
    "description": "Transforma is a forward-thinking solutions provider specializing in digital publishing, content transformation, and workflow process optimization across multiple industries.",
    "keywords": "about Transforma, digital publishing company, content transformation provider, online publishing platform, publishing technology experts, corporate vision and mission"
  },
  
  
};
const Aboutus = () => {
  return (
    <>
    <SEO
        title="About Transforma"
        description="Discover Transforma—a global leader in online publishing and content transformation. Driven by innovation, integrity, and excellence, we deliver cost-effective digital solutions across print, e-readers, tablets, and smartphones."
        keywords="about Transforma, digital publishing company, content transformation solutions, online publishing platform, publishing solutions provider, multi-medium content delivery, publishing industry expertise, open source system deployment"
        canonical="https://www.transforma.in/company/Aboutus"
        schema={aboutSchema}
      />
    <div className="w-full flex flex-col items-center ruler ">
      <Aboutus1 data={data} />
      <Aboutus2 data={data.section1} />
      <div className="2xl:container md:px-10 lg:px-20  px-6 pt-16 pb-12 md:pt-20 md:pb-16 w-full flex justify-center">
        <h4 className="text-24 sm:text-32 lg:text-48 text-primarycolor font-semibold lg:w-[90%] w-full text-center">{parse(data.section2.maintitle)}</h4>
      </div>
      <Section4 data={data.section2} />
      <Journey />

      <Leadership />
      <Testimonialnew />
    </div>
    </>
  );
};

export default Aboutus;
